var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeProgression(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.499,28.076c3.491,2.02,6.404,4.933,8.424,8.423c0.371,0.641,1.043,0.999,1.733,0.999c0.34,0,0.685-0.087,1-0.27 c0.956-0.553,1.282-1.776,0.729-2.732c-2.37-4.096-5.788-7.513-9.883-9.882c-0.957-0.554-2.18-0.227-2.733,0.729 C58.217,26.3,58.543,27.523,59.499,28.076z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,46c-1.104,0-2,0.896-2,2c0,12.683-10.317,23-23,23c-12.682,0-23-10.317-23-23c0-12.682,10.318-23,23-23 c1.104,0,2-0.896,2-2s-0.896-2-2-2c-14.888,0-27,12.112-27,27s12.112,27,27,27s27-12.112,27-27C75,46.896,74.104,46,73,46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,30.088c0-1.104-0.896-2-2-2s-2,0.896-2,2v17.909c0,0.01,0,0.02,0,0.029c0,0,0,0,0,0c0,0.002,0,0.003,0,0.004 c0,0,0,0,0,0c0.004,0.259,0.057,0.506,0.151,0.733c0.095,0.229,0.234,0.445,0.417,0.633c0,0.001,0.001,0.001,0.001,0.001 c0-0.002,0.001,0.002,0.003,0.003c0.005,0.005,0.01,0.011,0.015,0.016l7.257,7.257c0.391,0.391,0.902,0.586,1.414,0.586 s1.023-0.195,1.414-0.586c0.781-0.781,0.781-2.047,0-2.828L50,47.171V30.088z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeProgression);
export default __webpack_public_path__ + "static/media/time-progression.9d39e2f8580027135b18cc0f206aff2c.svg";
export { ForwardRef as ReactComponent };